import RootToken from '../../common/Color/RootToken';

export default RootToken;
